// src/features/design/ActivateTrueSizeSwitch.tsx
import React from "react";
import { Switch, Tooltip } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { HOTKEYS } from "../../../constants";
import { toggleShowTrueSizeOfDevicesInRedux } from "../../designSlice";

export const ActivateTrueSizeSwitch: React.FC = () => {
  const dispatch = useAppDispatch();
  const showTrueSizeOfDevices = useAppSelector((state) => state.design.showTrueSizeOfDevices);

  return (
    <Tooltip label="Vis komponenter i faktisk størrelse i takplan" position="bottom">
      <Switch
        checked={showTrueSizeOfDevices}
        onChange={() => dispatch(toggleShowTrueSizeOfDevicesInRedux())}
        label={`Vis riktig størrelse på komponenter`}
      />
    </Tooltip>
  );
};
